import { AddButton, CloseButton, TftfSelect } from 'assets/theme/StyledComponents';
import React, { useCallback, useEffect, useState } from 'react';
import Select, { ValueType } from 'react-select';
import { subscribeListener, unsubscribeListener } from 'redux/ably/sagas';
import { styled } from '../../assets/theme';
import { Modal } from '../Modal';

interface IWidgetOption {
	value: string,
	label: string,
	height: number,
	width: number,
	symbol?: string,
	isAdmin?: boolean
}

const widgetOptions: IWidgetOption[] = [
	{ value: 'advancer-decliner', label: 'Advancer/Decliner', height: 160, width: 550 },
	{ value: 'quotes', label: 'Quotes', height: 160, width: 1550 },
	{ value: 'events', label: 'Events', height: 500, width: 800 },
	{ value: 'chart', label: 'Full Chart', height: 850, width: 1350 },
	{ value: 'watchbox', label: 'WatchBox', height: 500, width: 1000 },
	{ value: 'watchboxItem', label: 'WatchBox Item', height: 710, width: 400, symbol: 'ES' },
	{ value: 'activeRotations', label: 'Active Rotations', height: 360, width: 1500 },
	{ value: 'completedRotations', label: 'Completed Rotations', height: 600, width: 1500 },
	{ value: 'modelOutput', label: 'Model Output', height: 285, width: 1200 },
	{ value: 'trendModel', label: 'Trend Model', height: 285, width: 1200 },
	{ value: 'esastamomo', label: 'STMomo', height: 500, width: 2000 },
];

export interface IAddHandlerParams {
	h: number, symbol?: string, type: string, width: number
}

interface IAddFormProps {
	showModal: boolean,
	closeHandler: () => void,
	addHandler: (params: IAddHandlerParams) => void
}

export const AddForm: React.FunctionComponent<IAddFormProps> = ({ showModal, closeHandler, addHandler }) => {
	const [selectedValue, setSelectedValue] = useState<IWidgetOption | undefined>();
	const [isAdmin, setIsAdmin] = useState(false)

	useEffect(() => {
		subscribeListener('store:authenticated', 2, ({ data }) => {
      setIsAdmin(!!data.isAdmin);
		});

    return () => {
      unsubscribeListener('store:authenticated', 2)
    }
	}, [])

	const closeModal = useCallback(() => {
		setSelectedValue(undefined);
		closeHandler();
	}, [closeHandler]);

	const handleCloseClick = useCallback(() => {
		closeModal();
	}, [closeModal]);

	const handleAddClick = useCallback(() => {
		if (selectedValue) {
			const option = widgetOptions.find(item => item.value === selectedValue.value);
			if (option) {
				addHandler({
					h: option.height,
					symbol: option.symbol,
					type: option.value,
					width: option.width,
				});
			}
		}
		closeModal();
	}, [addHandler, closeModal, selectedValue]);

	const handleWidgetChange = (option: ValueType<IWidgetOption, false>) => {
    if (!option) { return; }
    if (Array.isArray(option)) { return; }
		setSelectedValue((option as IWidgetOption));
	};

	return (
		<Modal shouldShow={showModal} title="Add a widget">
            <TftfSelect>
			    <Select
				    placeholder="Select widget type"
                    className="react-select"
                    classNamePrefix="react-select"
				    name="form-field-name"
				    value={selectedValue}
				    options={isAdmin ? widgetOptions : widgetOptions.filter(option => option.isAdmin !== true) }
				    onChange={handleWidgetChange}
			    />
            </TftfSelect>
			<AddFormFooter>
				<AddButton disabled={!selectedValue} onClick={handleAddClick}>Add</AddButton>
				<CloseButton onClick={handleCloseClick}>Close</CloseButton>
			</AddFormFooter>
		</Modal>
	);
};

const AddFormFooter = styled.div`
	display: grid;
	grid-auto-flow: column;
	justify-content: right;
	grid-gap: 1em;
	margin-top: 2em;
`;
